import { render } from "./KryptonField.vue?vue&type=template&id=34dcc456&lang=pug"
import script from "./KryptonField.vue?vue&type=script&lang=js"
export * from "./KryptonField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__